<div>
  <!-- Header -->
  <div class="sm:flex sm:items-center justify-between">
    <div class="sm:flex-auto">
      <h1 class="text-xl font-semibold text-gray-900">Whitelist Users</h1>
      <p class="mt-2 text-xs text-gray-700">A list of all whitelisted users.</p>
    </div>

    <!-- Search + Add Button -->
    <div class="flex items-center gap-4 mt-4 sm:mt-0">
      <div class="relative">
        <input
          type="text"
          placeholder="Search..."
          [(ngModel)]="searchQuery"
          (ngModelChange)="onSearchChange()"
          class="block w-64 rounded-md border border-gray-300 pl-3 pr-10 py-2 text-xs focus:border-indigo-500 focus:ring-indigo-500"
        />
      </div>

      <button
        type="button"
        (click)="openAddUserModal()"
        class="inline-flex items-center justify-center rounded-md border border-transparent bg-indigo-600 px-4 py-2 text-xs font-medium text-white shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 sm:w-auto"
      >
        Add Whitelist User
      </button>
    </div>
  </div>

  <!-- Table -->
  <div class="mt-8 flex flex-col">
    <div class="-my-2 -mx-4 overflow-x-auto sm:-mx-6 lg:-mx-8">
      <div class="inline-block min-w-full py-2 align-middle md:px-6 lg:px-8">
        <div class="overflow-hidden shadow md:rounded-lg">
          <table class="min-w-full divide-y divide-gray-300">
            <thead class="bg-gray-50">
              <tr>
                <th class="py-3.5 pl-4 pr-3 text-left text-xs font-semibold text-gray-900 sm:pl-6">Email</th>
                <th class="px-3 py-3.5 text-left text-xs font-semibold text-gray-900">Rule</th>
                <th class="px-3 py-3.5 text-left text-xs font-semibold text-gray-900">Created at</th>
                <th class="relative py-3.5 pl-3 pr-4 sm:pr-6"><span class="sr-only">Actions</span></th>
              </tr>
            </thead>
            <tbody class="divide-y divide-gray-200 bg-white">
              <tr *ngFor="let user of whitelistUsers">
                <td class="whitespace-nowrap py-4 pl-4 pr-3 text-xs font-medium text-gray-900 sm:pl-6">{{ user.email }}</td>
                <td class="whitespace-nowrap px-3 py-4 text-xs text-gray-500">{{ user.rule }}</td>
                <td class="whitespace-nowrap px-3 py-4 text-xs text-gray-500">{{ user.created_at }}</td>
                <td class="relative whitespace-nowrap py-4 pl-3 pr-4 text-right text-xs font-medium sm:pr-6">
                  <a (click)="deleteWhitelistUser(user.id)" class="text-indigo-600 hover:text-indigo-900 cursor-pointer">Delete</a>
                </td>
              </tr>

              <!-- Loading or Empty State -->
              <tr *ngIf="submitted || whitelistUsers.length === 0">
                <td colspan="8" class="py-6 text-center text-xs text-gray-500">
                  <ng-container *ngIf="submitted; else empty">
                    <div class="flex justify-center items-center gap-2">
                      <div class="w-5 h-5 border-4 border-blue-500 border-t-transparent rounded-full animate-spin"></div>
                      <span>Loading data...</span>
                    </div>
                  </ng-container>
                  <ng-template #empty>
                    Sorry, we couldn't find any results.
                  </ng-template>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- Pagination -->
        <div class="mt-8 flex justify-center">
          <nav class="inline-flex shadow-sm rounded-md">
            <button (click)="goToPreviousPage()" [disabled]="!previousPageUrl"
              class="px-3 py-2 bg-white border border-gray-300 text-xs rounded-l-md hover:bg-gray-50 disabled:opacity-50">‹</button>
            <button *ngFor="let page of pageNumbers"
              (click)="page !== '...' && loadWhitelistUsers(page)"
              [disabled]="page === '...' || currentPage === page"
              [ngClass]="{
                'bg-indigo-500 text-white': currentPage === page,
                'bg-white text-gray-700': currentPage !== page && page !== '...'
              }"
              class="px-4 py-2 border border-gray-300 text-xs">
              {{ page }}
            </button>
            <button (click)="goToNextPage()" [disabled]="!nextPageUrl"
              class="px-3 py-2 bg-white border border-gray-300 text-xs rounded-r-md hover:bg-gray-50 disabled:opacity-50">›</button>
          </nav>
        </div>
      </div>
    </div>
  </div>

  <!-- Modal (Outside Scrollable Container for z-index) -->
  <div *ngIf="isAddUserModalOpen" class="fixed inset-0 z-50 flex items-center justify-center bg-gray-900 bg-opacity-50">
    <div class="bg-white rounded-lg shadow-lg max-w-lg w-full p-6">
      <h3 class="text-lg font-semibold text-gray-900 mb-4">Add Whitelist User</h3>
      <input
        type="email"
        [(ngModel)]="newUserEmail"
        placeholder="Enter user email"
        class="block w-full mb-4 border border-gray-300 rounded-md px-3 py-2 text-xs focus:ring-indigo-500 focus:border-indigo-500"
      />
      <div class="flex justify-end gap-2">
        <button
          (click)="closeAddUserModal()"
          class="px-4 py-2 bg-gray-200 rounded-md hover:bg-gray-300"
        >Cancel</button>
        <button
          (click)="addWhitelistUser()"
          class="px-4 py-2 bg-indigo-600 text-white rounded-md hover:bg-indigo-700"
        >Add</button>
      </div>
    </div>
  </div>
</div>
